import * as React from 'react';
import { Box } from '@mui/material';
import BeachFlagChart from 'components/BeachFlagChart';

const FlagChart = ({input}) => {
	return (
		<Box className="FlagChart-root">
			<BeachFlagChart />
		</Box>
	)
}

export default FlagChart;